import { subMonths } from 'date-fns';

import type { GraphQLPledge } from '@sola/schema/dotcom/supporters/schema.generated.ts';

const recentPledgeMonths = 6;

export const filterRecentPledges = (
  pledges: GraphQLPledge[],
): GraphQLPledge[] => {
  const today = new Date();
  const sixMonthsAgo = subMonths(today, recentPledgeMonths);

  return pledges.filter((pledge) => {
    const dateToTest = pledge.lastInstallmentDate ?? pledge.endDate;
    return !(
      pledge.status === 'Completed' &&
      dateToTest &&
      new Date(dateToTest) < sixMonthsAgo
    );
  });
};
